import { deleteShippingApi } from "./deleteShippingApi";

export const deleteShippingSetData = async (
  lang,
  setMessageResponse,
  cookies,
  shipping_id,
  setSuccessMessage
) => {
  const response = await deleteShippingApi(shipping_id, lang, cookies);
  if (response.success) {
    setSuccessMessage((prev) => ({
      ...prev,
      success: true,
      data: response.res.data,
    }));
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
